// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
import VueI18n from 'vue-i18n';
import cookie from 'js-cookie';
// 在 main.js 中引入
import '@/assets/fontFamily/stylesheet.css'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.prototype.cookie = cookie;

//localeStorage中没有值得时候，默认语言‘zh’
const i18n = new VueI18n({
  locale: cookie.get('lang') || 'zh', // 语言标识,第一次登录默认是中文
  messages: {
    zh: require('../src/lang/zh'), // 汉语
    en: require('../src/lang/en'), // 英语
  }
})
// 使用相对路径，通过代理访问文件服务
Vue.prototype.$urlFile = "";
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>',
})
if (module.hot) {
  module.hot.accept(['../src/lang/zh', '../src/lang/en'], function () {
    i18n.setLocaleMessage('en', require('../src/lang/en').default)
    i18n.setLocaleMessage('zh', require('../src/lang/zh').default)
    // 同样可以通过 $i18n 属性进行热更新
  })
}



// WEBPACK FOOTER //
// ./src/main.js